import React, { FC } from 'react';
import { Text, Box, Image } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { ImageSource } from '@common/types';

export type TemplateDetailsProps = {
  templateName: string;
  businessName: string;
  templateMediaSources: ImageSource[];
};

const TemplateDetails: FC<TemplateDetailsProps> = ({
  templateName,
  businessName,
  templateMediaSources,
}) => {
  const { t } = useTranslation();

  return (
    <Box direction="horizontal" gap="18px" verticalAlign="middle">
      <Image
        showBorder
        src={templateMediaSources[0]?.url}
        width="54px"
        height="46px"
        alt="template image"
      />
      <Box direction="vertical" gap="2px" maxWidth="280px">
        <Text size="small" weight="bold" ellipsis={true} maxLines={1}>
          {t('marketplace.template-page.review-modal.template-info', {
            templateName: templateName,
          })}
        </Text>
        <Text size="tiny">
          {t('marketplace.template-page.review-modal.creator-info', {
            businessName: businessName,
          })}
        </Text>
      </Box>
    </Box>
  );
};

export default TemplateDetails;
